import {
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_DETAILS_FAILURE,
  GET_CUSTOMER_DETAILS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCustomerDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_DETAILS:
      return { ...state, loading: true };
    case GET_CUSTOMER_DETAILS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_CUSTOMER_DETAILS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCustomerDetailsReducer;
